import React from "react";
import { message, Spin, Table } from "antd";
import classNames from "classnames";
import { inject, observer } from "mobx-react";

import Language from "../language/language";
import agent from "../../agent";

import "./stylesheets/entryListModal.scss";

@inject("languageStore")
@observer
export default class EntryListModal extends React.Component {
  state = {
    loading: true,
    list: [],
    selectId: void 0
  };

  async componentDidMount() {
    if (
      this.props.info &&
      this.props.info.id &&
      this.props.info.registrations &&
      this.props.info.registrations.nodes &&
      this.props.info.registrations.nodes.length > 0 &&
      this.props.info.registrations.nodes[0].eventId
    ) {
      try {
        const eventId = this.props.info.registrations.nodes[0].eventId;
        const res = await agent.SassPlatform.getEntryLists(eventId, this.props.info.id);
        if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
          this.setState({
            list: res.data,
            loading: false,
            selectId: res.data[0].id
          });
        } else {
          this.setState({
            loading: false
          });
        }
      } catch (error) {
        console.error(error);
        message.error("加载失败，请重试！");
      }
    } else {
      this.setState({
        loading: false
      });
    }
  }

  handleClick = id => {
    this.setState({
      selectId: id
    });
  };

  renderListText = data => {
    return <span>{data.join(" ")}</span>;
  };

  render() {
    const { loading, list, selectId } = this.state;

    if (loading)
      return (
        <div className="entryListModal--loading">
          <Spin />
        </div>
      );

    const selectListData = list.find(item => item.id === selectId);
    const entryList = selectListData ? selectListData.list : [];

    const columns = [
      {
        title: <Language resource="NAME" />,
        dataIndex: "name",
        key: "name",
        width: 80,
        align: "center"
      },
      {
        title: <Language resource="H_SCHOOL" />,
        dataIndex: "school",
        key: "school",
        width: 150,
        align: "center"
      },
      {
        title: <Language resource="H_EDUCATION" />,
        dataIndex: "degree",
        key: "degree",
        width: 100,
        align: "center"
      },
      {
        title: <Language resource="POSITION" />,
        dataIndex: "position",
        key: "position",
        render: this.renderListText,
        width: 100,
        align: "center"
      },
      {
        title: <Language resource="DIRECTION" />,
        dataIndex: "target",
        key: "target",
        render: this.renderListText,
        width: 100,
        align: "center"
      }
    ];

    if (!(Array.isArray(list) && list.length > 0))
      return (
        <div className="entryListModal--loading">
          <Language resource="NO_DATA" />
        </div>
      );

    return (
      <div className="entryListModal">
        <div className="entryListModal__left">
          {list.map((item, index) => {
            return (
              <div
                key={`${item.id}-${index + 1}`}
                onClick={() => this.handleClick(item.id)}
                className={classNames([
                  "entryListModal__left--item",
                  selectId === item.id && "entryListModal__left--itemActive"
                ])}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <Table
          dataSource={entryList}
          columns={columns}
          className="entryListModal__table"
          pagination={false}
          rowKey={"userId"}
          scroll={{ x: false, y: 400 }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/controlCenter/entryListModal.js